import type { AdversaryRefusalReason } from "./adversary-refusal-reasons";

export interface LegalPositionPayload {
  winProbabilityPercentage: number;
  refusalReasonTypeId?: number | null;
  winProbabilityPercentageUpdateMessage: string | null;
  reasonForRefusalInternalExplanation: string | null;
  reasonForRefusalPublicExplanation: string | null;
}

/**
 * Builds the addEvent legalPosition payload — mirrors SendEventModal.addEvent
 * (Vue): only set when a win probability or a refusal reason was provided.
 */
export function buildLegalPositionPayload({
  winProbabilityPercentage,
  refusalReason,
}: {
  winProbabilityPercentage?: number;
  refusalReason?: AdversaryRefusalReason;
}): LegalPositionPayload | undefined {
  if (!winProbabilityPercentage && !refusalReason) {
    return undefined;
  }
  return {
    winProbabilityPercentage: winProbabilityPercentage || 0,
    refusalReasonTypeId: refusalReason?.id,
    winProbabilityPercentageUpdateMessage: null,
    reasonForRefusalInternalExplanation: null,
    reasonForRefusalPublicExplanation: null,
  };
}
